import { SvgIcon } from '@mui/material';
import React, { ReactElement } from 'react';

export interface AddIconProps {}

export const AddIcon = (_props: AddIconProps): ReactElement => {
  return (
    <SvgIcon style={{ fontSize: '1em' }} viewBox="0 0 20 20">
      <path
        id="Icon_awesome-plus-square"
        data-name="Icon awesome-plus-square"
        d="M17.857,2.25H2.143A2.143,2.143,0,0,0,0,4.393V20.107A2.143,2.143,0,0,0,2.143,22.25H17.857A2.143,2.143,0,0,0,20,20.107V4.393A2.143,2.143,0,0,0,17.857,2.25ZM16.429,13.5a.537.537,0,0,1-.536.536H11.786v4.107a.537.537,0,0,1-.536.536H8.75a.537.537,0,0,1-.536-.536V14.036H4.107a.537.537,0,0,1-.536-.536V11a.537.537,0,0,1,.536-.536H8.214V6.357a.537.537,0,0,1,.536-.536h2.5a.537.537,0,0,1,.536.536v4.107h4.107a.537.537,0,0,1,.536.536Z"
        transform="translate(0 -2.25)"
        fill="#24305f"
      />
    </SvgIcon>
  );
};
